import type { ReactNode } from 'react';

export const symbol_exposure_plus_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M810-200H508q-9.93 0-16.97-7.08-7.03-7.09-7.03-17.09V-260q0-4 7-17l200-204q34-35 49.5-64t15.5-60q0-42-25-66.5T662-696q-29 0-53 11.5T570-653q-8 11-20.5 14.5t-24.22-1.12Q512-645 506-656q-6-11 1-22 23-38 64.5-60t90.86-22q70.64 0 115.14 43T822-605q0 41-19 79t-64 83L563-263l2.47 3H810q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5ZM250-410H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h100v-100q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v100h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H310v100q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-100Z"
		/>
	</svg>
);
